function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import styles from "./register-form.scss";
import template from "./register-form.html";

export var RegisterFormComponent = {
  template: template,
  styles: styles,
  bindings: {},
  controller: /*#__PURE__*/function () {RegisterFormComponentController.$inject = ["NavigationStack"];
    function RegisterFormComponentController(NavigationStack) {
      "ngInject";_classCallCheck(this, RegisterFormComponentController);
      console.log(this);
      this.NavigationStack = NavigationStack;
    }_createClass(RegisterFormComponentController, [{ key: "onSubmit", value: function onSubmit(

      e) {
        localStorage.registered = 1;
        this.NavigationStack.pop({
          url: '/' });

      } }]);return RegisterFormComponentController;}() };